import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request the user did not initiate — a background refresh or a lazily loaded count.
 *
 * The global error interceptor shows a toast for every 5xx and every network failure, which is
 * right for an action someone is waiting on and wrong for background work: a fan-out of N
 * requests turns one outage into N toasts, and a retry doubles that. A caller that sets this
 * takes on responsibility for telling the user, once, if the failure is worth reporting at all.
 */
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/** Convenience for the common case of a single background call. */
export function backgroundRequest(): HttpContext {
  return new HttpContext().set(SUPPRESS_ERROR_TOAST, true);
}
